import { render, staticRenderFns } from "./DeleteUnrelClaimsPayDet.vue?vue&type=template&id=68bdddaa&"
import script from "./DeleteUnrelClaimsPayDet.vue?vue&type=script&lang=js&"
export * from "./DeleteUnrelClaimsPayDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports